exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.string-selection-container input[type=text].string-field.string-field-input {\n  border: solid 1px #bfc0c8;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.14);\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  width: 95%;\n  margin: 0 auto;\n  padding: 0 10px;\n}\n.string-selection-container input[type=text].string-field.string-field-input:focus {\n    outline: 0;\n    border-bottom-color: #00aef1;\n}\n", ""]);

// exports
